// IconContainer.js
import React, { useContext, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { Tooltip } from "bootstrap"; // Import Tooltip
import styles from "./IconContainer.module.css";
import DataContext from "../../store/data-context";

const IconContainer = ({ features }) => {
    const { sortedServiceFeatures } = useContext(DataContext);

    useEffect(() => {
        features.sort((a, b) => {
            return (
                sortedServiceFeatures.indexOf(a.key) -
                sortedServiceFeatures.indexOf(b.key)
            );
        });
    }, []);

    useEffect(() => {
        // Initialize Bootstrap tooltips on component mount
        const tooltipTriggerList = Array.from(
            document.querySelectorAll('[data-bs-toggle="tooltip"]')
        );

        const tooltips = tooltipTriggerList.map(
            (tooltipTriggerEl) => new Tooltip(tooltipTriggerEl)
        );

        // Cleanup tooltips on component unmount
        return () => tooltips.forEach((tooltip) => tooltip.dispose());
    }, []);

    const icons = features.map((el) => ({ class: el.icon, title: el.value }));

    return (
        <div
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            <div className={styles.description}>
                * značajke koje su omogućene uslugom
            </div>
            <div className={styles.iconContainer}>
                {icons.map((icon, index) => (
                    <i
                        key={index}
                        className={`bi ${icon.class} ${styles.icon}`}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title={icon.title}
                    ></i>
                ))}
            </div>
        </div>
    );
};

export default IconContainer;
